import React from 'react';
import moment from 'moment';
import propTypes from 'prop-types'
import commonMessage from '../../utils/commonMessage.json'

//mui material
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Chip, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

//components
import NetworkError from 'src/components/Error/networkError';
import { CustomSkeleton } from '../../sections/skeleton/skeletonLoader';

// Show table filtes.
const TableFilterSection = styled('div')(() => ({
  width: 'auto',
  padding: '16px 16px 16px 16px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center'
}));

export const PaginationTable = ({
  page = 0,
  tableFilter,
  ActionJsx,
  ActionModals,
  setPage,
  rowsPerPage = 10,
  setRowsPerPage,
  setLoad,
  count = 0,
  error = false,
  loading,
  setLoading,
  rows,
  columns,
  size = "small",
  calculatedHeight = 0
}) => {

  const handleChangePage = (e, newPage) => {
    setPage(newPage)
    setLoad(true);

    // setLoading(true)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setLoad(true)
    setLoading(true)
  };

  const dateFormatJsx = (id, align, value) => {
    const date = moment(value * 1000);
    const formattedDate = date.format('D MMM, YYYY');

    return (
      <TableCell
        key={id}
        align={align}
        sx={{
          color: 'grey.700',
          borderBottom: '0.5px dashed',
          borderColor: 'grey.300',
        }}>
        <>
          <Box>{formattedDate}</Box>

        </>
      </TableCell>)
  }

  const defaultRowJsx = (id, align, value) => (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}>
      {value || "--"}
    </TableCell>
  )

  const actionJsx = (id, align, value, row) => {
    return <ActionJsx key={id} id={id} align={align} value={value} row={row} />
  }

  const activeJsx = (id, align, value, row) => {
    return <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
      }}>
      {value ? <Chip label="Active" color={"success"} /> : <Chip label="Inactive" color={"error"} />}
    </TableCell>
  }

  const tableRowData = {
    create_date: dateFormatJsx,
    actions: actionJsx,
    active: activeJsx
  }

  return (
    <Paper sx={{
      overflow: 'hidden',
      backgroundColor: 'grey.1000',
      borderRadius: '6px'
    }}>

      <TableFilterSection>
        {tableFilter}
      </TableFilterSection>

      <TableContainer sx={{ maxHeight: window.innerHeight - calculatedHeight }}>
        <Table stickyHeader aria-label="sticky table" size={size}>

          <TableHead sx={{
            position: "sticky"
          }} >
            <TableRow >
              {columns.map(({ id, align, minWidth, label }) => (
                <TableCell
                  key={id}
                  align={align}
                  style={{ minWidth }}
                  sx={{
                    backgroundColor: 'grey.200',
                    color: 'grey.600',
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {!loading ?
            <TableBody>
              {rows.map((row) =>
              (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row?.userId || row?.email}
                >
                  {columns.map(({ id, align }) => (tableRowData?.[id] || defaultRowJsx)(id, align, row[id], row))}
                </TableRow>
              )
              )}
            </TableBody>
            :
            <TableBody>
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
              >
                {columns.map(({ id, align }) => (
                  <TableCell
                    key={id}
                    align={align}
                    sx={{
                      color: 'grey.300',
                      borderBottom: '1px solid',
                      borderColor: 'grey.800',
                    }}
                  >
                    <CustomSkeleton variant={"text"} component={"h6"} width={"100%"} />
                  </TableCell>
                ))}
              </TableRow>

            </TableBody>
          }
        </Table>
      </TableContainer>

      {count > 0 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            backgroundColor: 'grey.1000',
            color: 'grey.700',
          }}
        />
      )}

      {!(count || loading) &&
        < Box sx={{
          height: {
            xs: "480px",
            sm: "480px",
            md: "480px",
            lg: "480px",
            xl: "670px",
          },
          display: 'flex',
          justifyContent: 'center'
        }}>
          <NetworkError message={!error ? commonMessage?.noDataFound : commonMessage?.networkError} calculatedHeight={calculatedHeight} />
        </Box>
      }
      {ActionModals && <ActionModals />}
    </Paper>
  )
}



PaginationTable.propTypes = {
  page: propTypes.number,
  setPage: propTypes.func.isRequired,
  rowsPerPage: propTypes.number,
  setRowsPerPage: propTypes.func.isRequired,
  setLoad: propTypes.func.isRequired,
  count: propTypes.number,
  error: propTypes.bool,
  loading: propTypes.bool,
  setLoading: propTypes.func,
  rows: propTypes.array.isRequired,
  columns: propTypes.array.isRequired,
  maxHeight: propTypes.number,
}
